module.exports = __webpack_public_path__ + "statics/img/ywl_android.fc758151.jpg";